import { defineStore } from "pinia";
import type { Toast, ToastType } from "@/types/toast";
import axios from "@/api/axios";
import {ForecastData} from "@/types/files";
import {useFilesStore} from "@/stores/files";

export const useStore = defineStore("mainStore", {
  state: () => ({
    count: 0,
    currentForecast: null as ForecastData | null, // Данные прогноза
    forecastStatus: true, // Статус формирования прогноза.
    forecastStatusDisplay: false, // Отображение прогноза
    toasts: [] as Toast[], // Массив активных уведомлений
  }),

  getters: {},

  actions: {
    /**
     * GET /api/metrics/predictions
     * Получение данных прогноза
     * @param region - Выбранный регион
     * @param federalDistrict - Выбранный федеральный округ
     */
    async getForecast(region?: string, federalDistrict?: string) {
      const params: Record<string, string> = {};

      if (region) {
        params.regions = region;
      }

      if (federalDistrict) {
        params.federal_districts = federalDistrict;
      }

      const response = await axios.get<ForecastData>(
          "/oracul/api/metrics/predictions",
          { params }
      );

      console.log("Get forecast response:", response);
      this.currentForecast = response.data;
      return response.data;
    },

    async toggleForecastStatusDisplay() {
      if (!this.forecastStatusDisplay) {
        const filesStore = useFilesStore();
        const region = filesStore.selectedRegionKey || undefined;
        const district = filesStore.selectedDistrictKey || undefined;

        await this.getForecast(region, district);
      }

      this.forecastStatusDisplay = !this.forecastStatusDisplay;
      if (this.forecastStatusDisplay) {
        this.addToast("warning",
            "Вы находитесь в режиме прогноза",
            "Все параметры, отображаемые на экране, являются прогнозом и могут изменяться по мере поступления новых данных в БД.");
      }
    },

    /**
     * Добавление нового уведомления
     * @param type - Тип уведомления (success, error, warning, info)
     * @param title - Заголовок уведомления
     * @param message - Опциональное сообщение
     * @param duration - Длительность показа в миллисекундах (по умолчанию 8000)
     */
    addToast(type: ToastType, title: string, message?: string, duration = 8000) {
      const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      const toast: Toast = {
        id,
        type,
        title,
        message,
        duration,
      };

      this.toasts.push(toast);

      // Автоматическое удаление уведомления через заданное время
      if (duration > 0) {
        setTimeout(() => {
          this.removeToast(id);
        }, duration);
      }
    },

    /**
     * Удаление уведомления по ID
     * @param id - Идентификатор уведомления
     */
    removeToast(id: string) {
      const index = this.toasts.findIndex(toast => toast.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    },

    /**
     * Вспомогательные методы для быстрого создания уведомлений разных типов
     */
    showSuccess(title: string, message?: string, duration?: number) {
      this.addToast("success", title, message, duration);
    },

    showError(title: string, message?: string, duration?: number) {
      this.addToast("error", title, message, duration);
    },

    showWarning(title: string, message?: string, duration?: number) {
      this.addToast("warning", title, message, duration);
    },

    showInfo(title: string, message?: string, duration?: number) {
      this.addToast("info", title, message, duration);
    },
  },
});